<template>
  <button type="button" class="custom-ui-button-wrapper" :class="classes" :disabled="disabled">
    <span v-if="!loading" class="custom-ui-button-label">
      <span v-if="label" v-text="label" />
      <span class="ml05" v-if="icon">
        <i :class="icon" />
      </span>
    </span>
    <div v-else class="spinner-button">
      <i class="fa-solid fa-spinner" />
    </div>
  </button>
</template>

<script lang="ts" setup>
  import type { IButton } from '@/types/Components'
  import { computed, inject } from 'vue'

  const {
    type = 'primary',
    loading = false,
    disabled = false,
    size = 'sm',
    label = '',
    icon = '',
    expanded = false,
  } = defineProps<IButton>()

  const isMobile = inject('isMobile', false)

  const classes = computed(() => {
    const actualExpanded = isMobile ? true : expanded

    return [
      disabled ? 'type-disabled' : `type-${type}`,
      `size-${size}`,
      disabled ? 'disabled' : '',
      actualExpanded ? 'expanded' : '',
    ]
  })
</script>

<style lang="scss">
  .custom-ui-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 5px;
    padding: calc(0.5em) 1em;

    cursor: pointer;
    transition: 0.2s ease;
    white-space: nowrap;
    &.disabled {
      cursor: not-allowed;
    }
    &.expanded {
      width: 100%;
      .custom-ui-button-label {
        text-align: center;
        width: 100%;
        display: flex;
        justify-content: center;
        white-space: nowrap;
      }
    }
    a {
      color: inherit;
      text-decoration: none;
      width: 100%;
      height: 100%;
    }

    .spinner-button {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
</style>
